import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

// #redesign Welle A — kapselt das wiederkehrende Idiom "Referenz auf eine andere Entity":
//   - keine id        → "—"
//   - id + aufgelöst   → klickbarer Link (Name/Email statt roher UUID)
//   - id, noch ladend  → mono-id (neutral, kein voreiliges "orphaned")
//   - id, geladen aber nicht gefunden → orphaned-Badge (Ziel existiert nicht mehr)
// stopPropagation, damit der Link in einer klickbaren Tabellen-Row nicht die Row-Navigation auslöst.
export function EntityLink({
  to,
  id,
  label,
  isResolving = false,
}: {
  to: string;
  id: string | null | undefined;
  label: string | null | undefined;
  isResolving?: boolean;
}) {
  if (!id) return <span className="text-subtext0">—</span>;
  if (label) {
    return (
      <Link
        to={to}
        className="text-blue hover:underline"
        onClick={(e) => e.stopPropagation()}
      >
        {label}
      </Link>
    );
  }
  if (isResolving) {
    return <span className="font-mono text-xs text-subtext0">{id}</span>;
  }
  // Annahme: eine aufgelöste Entity hat immer ein nicht-leeres Label (User→email,
  // Node→hostname). Leeres label + !isResolving wird daher als orphaned gewertet.
  return <Badge variant="orphaned">orphaned: {id}</Badge>;
}
